export default __webpack_public_path__ + "static/company-1-b972b5eb824f221e80d787b7832695e3.png";